export default __webpack_public_path__ + "static/media/2.16cf3b70.jpeg";